<template>
    <div class="cart__page">
        <h1>Mes Favoris</h1>
        
            <ProductsGrid  :productsArray="cardArray" :addvisible='false' :removeIsVisible='true'/>
        </div>

</template>

<script>
    
    import Card from "../mixins/Card";
    import TitlePage from "../components/TitlePage";
    import ProductsGrid from "../components/ProductsGrid"
    import Button from "../components/Button";
    import ApiProduct from  "../mixins/ApiProducts"

    export default {
        name:"ShoppingCart",
        mixins:[Card,ApiProduct],
        components:{
            TitlePage,
            Button,
            ProductsGrid
        },
        data: function () {
            return {
                cardArray:[],
                product:{},
            }
        },
        mounted() {
            this.cardArray=this.$store.state.cart;
     
        },

        computed : {

        },
        filters: {

        },
        methods: {
            clearCartAndRefresh: function() {
                this.clearCart();
            }
        },
        watch:{
            cardArray: function(){
                this.$store.state.cart
            }
        }

    }

</script>

<style lang="scss" scoped>
.cart__page{

    padding: 3%;

    h1{
        color: #fff;
        text-align: center;
    }
    .button__clear{
        width: fit-content;
        margin: 0 auto;
        button:hover{

            background-color: #9c0204 ;
            color: #fff;
        }
    }
    height: 75vh;
    overflow-x: auto;
}

.cart__page::-webkit-scrollbar {
    margin:20px;
    width: 5px;
    background: #888;
    border-radius:10px;
}
.cart__page::-webkit-scrollbar-thumb {
    background: #000000;
    border-radius:10px;
    
}
</style>